// material-ui

import longHeavyCertificate from '../../../assets/images/qualifications/long-heavy-certificate.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const LongHeavyCertificate = (props) => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={longHeavyCertificate} alt="LongHeavyCertificate" height={props.height || 24}  />
    );
};

export default LongHeavyCertificate;